import { Controller } from '@hotwired/stimulus'

const VISIBLE = 'rnk-Comparativa_Barra-visible'

// Barra fija al pie de la comparativa de ETFs (ENH-RNK-044, `_comparar_tabla.haml`) con un botón de comprar por
// ETF. Comprar va al final de la tabla, cuando ya se ha visto en qué se diferencian; esta barra lo acerca a quien
// baja por ella: sale cuando el gráfico (o la primera sección, si no hay gráfico) ha quedado arriba, y se va
// mientras la fila de comprar está a la vista, que ya lleva los mismos botones. Se observan los elementos y no
// el scroll, como en `barra_cta_movil_controller.js`. Cada botón abre el desplegable de brókers de su ETF en esa
// fila; sin JS, el enlace baja hasta ella.
export default class extends Controller {
  connect () {
    this.pasado = false
    this.filaALaVista = false
    this.observadores = []

    const umbral = document.querySelector('#comparar-evolucion') || document.querySelector('.rnk-Comparativa_Bloque')
    const fila = document.querySelector('#comparar-comprar')
    if (!umbral || !fila) return

    this.observa(umbral, entrada => { this.pasado = !entrada.isIntersecting && entrada.boundingClientRect.top < 0 })
    this.observa(fila, entrada => { this.filaALaVista = entrada.isIntersecting })
  }

  disconnect () {
    this.observadores.forEach(observador => observador.disconnect())
    this.observadores = []
    this.element.classList.remove(VISIBLE)
  }

  // Abre el desplegable de brókers de ese ETF en la fila de comprar, que además baja hasta él. Después de este
  // clic y no durante: `dropdownable.js` escucha los clics del documento y cerraría lo que se abra mientras
  // este todavía sube. Sin desplegable (promoción sin brókers), solo baja hasta la celda.
  comprar (evento) {
    const cta = document.getElementById(evento.params.id)
    if (!cta) return

    evento.preventDefault()
    const disparador = cta.querySelector('dropdown-toggle')
    if (disparador) {
      setTimeout(() => disparador.click(), 0)
    } else {
      cta.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  observa (elemento, anota) {
    const observador = new IntersectionObserver(([entrada]) => {
      anota(entrada)
      this.pinta()
    })
    observador.observe(elemento)
    this.observadores.push(observador)
  }

  pinta () {
    this.element.classList.toggle(VISIBLE, this.pasado && !this.filaALaVista)
  }
}
